import { createApi } from '@reduxjs/toolkit/dist/query/react'
import baseQueryWithIam from '../../app/baseQueryWithIam'
import {
    PurchaseState,
    CourseSubjectPriceState,
    PriceState,
    getCourseSubjectPricesParams,
} from '../types'

interface freeStartCourseParams {
    languageEnum: string
    courseSubjectPriceIds: number[]
}

export const courseSubjectPriceApi = createApi({
    reducerPath: 'courseSubjectPriceApi',
    baseQuery: baseQueryWithIam,
    tagTypes: [],
    endpoints: (build) => ({
        createCourseSubjectsPrice: build.mutation<
            void,
            CourseSubjectPriceState[]
        >({
            query: (courseSubjectsPrice) => ({
                url: 'course-subject-price/list',
                method: 'POST',
                body: courseSubjectsPrice,
            }),
        }),

        getCourseSubjectsPricesByCoursePrice: build.query<
            CourseSubjectPriceState[],
            number
        >({
            query: (coursePriceId) => ({
                url: `course-subject-price/${coursePriceId}`,
            }),
            transformResponse: (response: any) => response.data,
        }),

        getPurchaseDetailsByCoursePrice: build.query<PurchaseState, number>({
            query: (coursePriceId) => ({
                url: `/purchase/${coursePriceId}`,
            }),
            transformResponse: (response: any) => response.data,
        }),

        getCourseSubjectPrices: build.mutation<
            PriceState,
            getCourseSubjectPricesParams[]
        >({
            query: (courseSubjects) => ({
                url: 'purchase',
                method: 'POST',
                body: courseSubjects,
            }),
            transformResponse: (response: any) => response.data,
        }),

        startFreeCourse: build.mutation<any, freeStartCourseParams>({
            query: (body) => ({
                url: 'purchase/free-start',
                method: 'POST',
                body,
            }),
            transformResponse: (response: any) => response.data,
        }),
    }),
})
